import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { API, graphqlOperation } from "aws-amplify";
import { updateAudit, updateProduct } from "../../../graphql/mutations";

import { makeStyles } from "@material-ui/core/styles";

import {
  useNotify,
  SaveButton,
  FormDataConsumer,
  useRefresh,
} from "react-admin";
import { useForm, useFormState } from "react-final-form";

import { ConditionalConfirm } from "../../../components/common/ConditionalConfirm";
import { getCustomFieldsToSave } from "../../../components/common/CustomFields";
import { ApproveIcon } from "../../../components/common/iconography";
import { logError } from "../../../utils/appUtils";
import { InventoryStatus, NoteType } from "../../../utils/constants";
import {
  deepRedirect,
  historyAutoGen,
  normalizeValue,
} from "../../../utils/utils";
import {
  formValidate,
  validateInventoryBeforeUpdate,
} from "../../../managerApp/resources/inventory/InventoryUitls";
import { sanitizeInventory } from "../../../graphql/inventory/inventoryCRUD";
import { getProduct } from "../../../graphql/queries";

const useStyles = makeStyles((theme) => ({
  saveButton: {
    marginRight: theme.spacing(2),
  },
}));

const updateReconcileAudit = async (audit, inventory) => {
  debugger;
  const updateProcessedItems = audit.processedItems.map((itm) =>
    itm.id !== inventory.id
      ? itm
      : {
          ...itm,
          reconciledQuantityOnHand: inventory.quantityOnHand,
          reconciledQuantityPhysical: inventory.quantityPhysical,
        },
  );

  const toUpdateAudit = {
    ...audit,
    processedItems: JSON.stringify(updateProcessedItems),
    processedLocations: JSON.stringify(audit.processedLocations),
    skippedItems: JSON.stringify(audit.skippedItems),
  };

  delete toUpdateAudit.account;
  delete toUpdateAudit.location;
  delete toUpdateAudit.product;
  delete toUpdateAudit.reconcileList;
  delete toUpdateAudit.updatedAt;
  await API.graphql(graphqlOperation(updateAudit, { input: toUpdateAudit }));
};

export const DialogSaveButton = ({
  record,
  backPath,
  reconcileAudit,
  validateQty,
  validateNotes,
  isSaving,
  setIsSaving,
  isDeleting,
  ...props
}) => {
  const classes = useStyles();
  const form = useForm();
  const history = useHistory();
  const notify = useNotify();
  const refresh = useRefresh();
  const [open, setOpen] = useState(false);
  const [confirmContent, setConfirmContent] = useState("");
  const isAdviceReview = record.status === InventoryStatus.ADVICE_REVIEW;

  const handleDialogConfirm = () => handleSave();
  const handleDialogClose = () => setOpen(false);
  const [onConfirm, setOnConfirm] = useState(() => handleDialogConfirm);

  const getAcceptLabel = (formData) => {
    if (formData.status === InventoryStatus.REVIEW) return "Complete";
    else return "Accept";
  };

  const handleValidateSave = async (formData) => {
    const tempMsg = [];
    setOnConfirm(() => handleDialogConfirm); // Allow confirmation if no error
    setIsSaving(true);
    debugger;

    const isValid = formValidate(form, notify);
    if (!isValid) {
      setIsSaving(false);
      handleSave(); // trigger field-level validation
      return;
    }

    try {
      // Stale inventory validation:
      const { staleErrors } = await validateInventoryBeforeUpdate(
        formData,
        notify,
      );

      // If any staleErrors: force a refresh via Confirm
      if (staleErrors.length > 0) {
        setConfirmContent(
          <div>
            <p>Data was modified by another user while you were editing:</p>
            <ul>
              {staleErrors.map((msg, idx) => (
                <li key={idx}>{msg}</li>
              ))}
            </ul>
            <p>Confirm to refresh and apply your edits again.</p>
          </div>,
        );
        setOnConfirm(() => () => {
          setOpen(false);
          refresh();
        });
        setOpen(true);
        setIsSaving(false);
        return;
      }
    } catch (err) {
      logError(
        "inventory:DialogSaveButton:validateInventoryBeforeUpdate",
        err,
        notify,
      );
      setIsSaving(false);
    }

    if (
      formData.overShipment &&
      formData.quantityAdvised >= formData.quantityReceived
    ) {
      tempMsg.push(
        "Errors Found: Overshipment Exception should be cleared before saving.",
      );
      setOnConfirm(null); // Prevent confirmation if there's an error
    } else if (
      formData.underShipment &&
      formData.quantityAdvised <= formData.quantityReceived
    ) {
      tempMsg.push(
        "Errors Found: Undershipment Exception should be cleared before saving.",
      );
      setOnConfirm(null); // Prevent confirmation if there's an error
    } else if (validateNotes(form, formData)) {
      tempMsg.push(
        "Don't forget to document all Quantity changes in the Notes! " +
          "Proceed without a Note?",
      );
    }

    if (tempMsg.length === 1) {
      setConfirmContent(tempMsg[0]);
      setOpen(true);
      setIsSaving(false);
    } else if (tempMsg.length > 1) {
      setConfirmContent(
        <ul>
          {tempMsg.map((msg) => (
            <li>{msg}</li>
          ))}
        </ul>,
      );
      setOpen(true);
      setIsSaving(false);
    } else handleSave();
  };

  const handleValidateSaveAccept = async (formData) => {
    debugger;
    const tempMsg = [];
    setOnConfirm(() => handleDialogConfirm); // Allow confirmation if no error

    const isValid = formValidate(form, notify);
    if (!isValid) {
      setIsSaving(false);
      handleSave(); // trigger field-level validation
      return;
    }

    try {
      setIsSaving(true);
      // Stale inventory validation:
      const { staleErrors } = await validateInventoryBeforeUpdate(
        formData,
        notify,
      );

      // If any staleErrors: force a refresh via Confirm
      if (staleErrors.length > 0) {
        setConfirmContent(
          <div>
            <p>Data was modified by another user while you were editing:</p>
            <ul>
              {staleErrors.map((msg, idx) => (
                <li key={idx}>{msg}</li>
              ))}
            </ul>
            <p>Confirm to refresh and apply your edits again.</p>
          </div>,
        );
        setOnConfirm(() => () => {
          setOpen(false);
          refresh();
        });
        setOpen(true);
        setIsSaving(false);
        return;
      }
    } catch (err) {
      logError(
        "inventory:DialogSaveButton:validateInventoryBeforeUpdate",
        err,
        notify,
      );
      setIsSaving(false);
    }

    let qtyCheck = validateQty(formData);
    if (
      (formData.status === InventoryStatus.ARRIVED ||
        formData.status === InventoryStatus.REVIEW) &&
      formData.verificationRequired === "true" &&
      qtyCheck?.quantityAdvised
    ) {
      tempMsg.push(
        "Errors Found : Quantity Advised and Received do not match! Item will not be Accepted.",
      );
      setOnConfirm(null); // Prevent confirmation if there's an error
    } else if (qtyCheck?.quantityAdvised) {
      // probably no longer needed
      tempMsg.push(
        "Errors Found : Quantity Advised and Received do not match!",
      );
      setOnConfirm(null); // Prevent confirmation if there's an error
    } else if (qtyCheck?.quantityOnHand) {
      tempMsg.push(
        "Errors Found : Quantity On Hand and Physical do not match!",
      );
      setOnConfirm(null); // Prevent confirmation if there's an error
    }
    if (validateNotes(form, formData)) {
      tempMsg.push(
        " Don't forget to document Quantity changes in the Notes! " +
          "Proceed without adding a Note?",
      );
    }

    if (tempMsg.length === 1) {
      setConfirmContent(tempMsg[0]);
      setOpen(true);
      setIsSaving(false);
    } else if (tempMsg.length > 1) {
      setConfirmContent(
        <ul>
          {tempMsg.map((msg) => (
            <li>{msg}</li>
          ))}
        </ul>,
      );
      setOpen(true);
      setIsSaving(false);
    } else handleSave();
  };

  const handleSave = () => {
    debugger;
    setOpen(false);
    props.handleSubmitWithRedirect();
  };

  const addProductAltNames = (product, data) => {
    const altNameSet = new Set();
    if (data.productName != null && String(data.productName).trim() !== "") {
      product.altNames?.forEach((altName) => {
        if (altName != null && String(altName).trim() !== "") {
          altNameSet.add(altName);
        }
      });
      altNameSet.add(data.productName);
      if (
        data.braRawProductName != null &&
        String(data.braRawProductName).trim() !== ""
      ) {
        altNameSet.add(data.braRawProductName);
      }
    }
    return Array.from(altNameSet);
  };

  const removeProductAltNames = (product, data) => {
    const altNameSet = new Set();
    if (data.productName != null && String(data.productName).trim() !== "") {
      product.altNames?.forEach((altName) => {
        if (altName != null && String(altName).trim() !== "") {
          altNameSet.add(altName);
        }
      });
      altNameSet.delete(data.productName);
      if (
        data.braRawProductName != null &&
        String(data.braRawProductName).trim() !== ""
      ) {
        altNameSet.delete(data.braRawProductName);
      }
    }
    return Array.from(altNameSet);
  };

  const updateProductAltNames = async (record, data) => {
    if (!isAdviceReview) return;

    // client linked to a new product
    if (!record.productId && data.productId) {
      // get newProduct from DB
      const newProduct = await API.graphql(
        graphqlOperation(getProduct, { id: data.productId }),
      );
      let newProductAltNames = newProduct.data.getProduct?.altNames || [];
      newProductAltNames = addProductAltNames(newProduct.data.getProduct, data);
      await API.graphql(
        graphqlOperation(updateProduct, {
          input: { id: data.productId, altNames: newProductAltNames },
        }),
      );
    }

    // client unlinked from a product
    if (record.productId && !data.productId) {
      const oldProduct = record.product;
      const id = record.productId;
      let oldProductAltNames = record.product.altNames;
      oldProductAltNames = removeProductAltNames(oldProduct, data);
      await API.graphql(
        graphqlOperation(updateProduct, {
          input: { id, altNames: oldProductAltNames },
        }),
      );
    }

    // client accepted the advice
    if (data?.productId && record?.productId === data?.productId) {
      const newProduct = await API.graphql(
        graphqlOperation(getProduct, { id: data.productId }),
      );
      let newProductAltNames = newProduct.data.getProduct?.altNames || [];
      newProductAltNames = addProductAltNames(newProduct.data.getProduct, data);
      await API.graphql(
        graphqlOperation(updateProduct, {
          input: { id: data.productId, altNames: newProductAltNames },
        }),
      );
    }

    // client relinked to a new product
    if (
      record.productId &&
      data.productId &&
      record.productId !== data.productId
    ) {
      // get newProduct from DB
      const newProduct = await API.graphql(
        graphqlOperation(getProduct, { id: data.productId }),
      );
      let newProductAltNames = newProduct.data.getProduct?.altNames || [];
      newProductAltNames = addProductAltNames(newProduct.data.getProduct, data);
      await API.graphql(
        graphqlOperation(updateProduct, {
          input: { id: data.productId, altNames: newProductAltNames },
        }),
      );
      const oldProduct = record.product;
      let oldProductAltNames = record.product.altNames;
      oldProductAltNames = removeProductAltNames(oldProduct, data);
      await API.graphql(
        graphqlOperation(updateProduct, {
          input: { id: record.productId, altNames: oldProductAltNames },
        }),
      );
    }
  };

  const transformAccpet = async (data) => {
    setIsSaving(true);
    debugger;
    let historyNote = null;

    if (data.status === InventoryStatus.REVIEW) {
      data.status = InventoryStatus.STORED;
    }
    if (data.status === InventoryStatus.UNLOADED) {
      data.status = InventoryStatus.ARRIVED;
    }

    data.verificationRequired = "resolved";
    historyNote = {
      text: `Accepted by ${window.appUser?.fullName}`,
      type: NoteType.INVENTORY,
      date: new Date(),
      by: window.appUser?.fullName,
    };
    data.history = [...data.history, historyNote];

    return await transform(data);
  };

  const transform = async (data) => {
    data = { ...data };
    setIsSaving(true);
    let historyNotes = [];
    debugger;
    await updateProductAltNames(record, data);
    data.customFields = getCustomFieldsToSave(
      data.customFields,
      data.account.inventoryCustomFields,
    );

    if (form.getFieldState("quantityAdvised")?.dirty) {
      let note = {
        type: NoteType.INVENTORY,
        date: new Date(),
        by: window.appUser?.fullName,
        text: `Qty. Advised Changed from ${
          form.getFieldState("quantityAdvised")?.initial
        } to ${form.getFieldState("quantityAdvised")?.value}`,
      };
      historyNotes = [...historyNotes, note];
    }
    if (form.getFieldState("quantityReceived")?.dirty) {
      let note = {
        type: NoteType.INVENTORY,
        date: new Date(),
        by: window.appUser?.fullName,
        text: `Qty. Received Changed from ${
          form.getFieldState("quantityReceived")?.initial
        } to ${form.getFieldState("quantityReceived")?.value}`,
      };
      historyNotes = [...historyNotes, note];
    }
    if (form.getFieldState("quantityOnHand")?.dirty) {
      let note = {
        type: NoteType.INVENTORY,
        date: new Date(),
        by: window.appUser?.fullName,
        text: `Qty. OnHand Changed from ${
          form.getFieldState("quantityOnHand")?.initial
        } to ${form.getFieldState("quantityOnHand")?.value}`,
      };
      historyNotes = [...historyNotes, note];
    }
    if (form.getFieldState("quantityPhysical")?.dirty) {
      let note = {
        type: NoteType.INVENTORY,
        date: new Date(),
        by: window.appUser?.fullName,
        text: `Qty. Physical Changed from ${
          form.getFieldState("quantityPhysical")?.initial
        } to ${form.getFieldState("quantityPhysical")?.value}`,
      };
      historyNotes = [...historyNotes, note];
    }
    if (form.getFieldState("productName")?.dirty) {
      let note = {
        type: NoteType.INVENTORY,
        date: new Date(),
        by: window.appUser?.fullName,
        text: `Name Changed from ${
          form.getFieldState("productName")?.initial
        } to ${form.getFieldState("productName")?.value}`,
      };
      historyNotes = [...historyNotes, note];
    }

    if (historyNotes?.length > 0) {
      data.history = [...data.history, ...historyNotes];
    }

    const ignoreList = [
      "status",
      "quantityAdvised",
      "quantityReceived",
      "quantityOnHand",
      "quantityPhysical",
      "productId",
      "productName",
      "areaId",
      "zoneId",
      "auditId",
      "reloadYardCommodityId",
      "verificationRequired",
      "receivedAt",
      "depletedAt",
      "turnDays",
    ];
    const includeArrayList = ["customFields"];
    data.history = historyAutoGen(form, data, ignoreList, includeArrayList);

    debugger;
    if (data.notes?.length > 0) {
      data.notes.forEach((element) => {
        if (!element.date) {
          element.type = NoteType.GENERIC;
          element.date = new Date();
          element.by = window.appUser?.fullName;
        }
      });
    } else data.notes = undefined;

    if (
      data.status === InventoryStatus.STORED &&
      data.quantityOnHand === data.quantityPhysical
    ) {
      data.quantityMismatch = false;
    }

    data.normalizedPoNumber = normalizeValue(data.poNumber);
    data.normalizedRailCarNumber = normalizeValue(data.railCarNumber);

    data = sanitizeInventory(data);

    return data;
  };

  const onSuccess = async ({ data }) => {
    debugger;
    try {
      if (reconcileAudit) await updateReconcileAudit(reconcileAudit, data);

      notify("Inventory updated successfully", "success");
      deepRedirect(history, backPath);
    } catch (error) {
      logError("inventory:DialogSaveButton:onSuccess", error, notify);
    } finally {
      setIsSaving(false);
    }
  };

  const onFailure = (error) => {
    setIsSaving(false);
    logError(
      "inventory:DialogSaveButton:onFailure:Inventory Update",
      error,
      notify,
    );
  };

  const { pristine, submitting } = useFormState({ subscription: { pristine: true, submitting: true } });

  // Pass ...props, not ...rest to FormDataConsumer to include handleSubmitWithRedirect from props
  return (
    <FormDataConsumer>
      {({ formData, ...props }) => (
        <>
          <div>
            <SaveButton
              label="Save"
              className={classes.saveButton}
              submitOnEnter={false}
              undoable={false}
              disabled={pristine || isSaving || isDeleting}
              saving={isSaving || submitting}
              handleSubmitWithRedirect={() => handleValidateSave(formData)}
              transform={transform}
              onSuccess={onSuccess}
              onFailure={onFailure}
            />
            {formData.verificationRequired === "true" && (
              <SaveButton
                label={getAcceptLabel(formData)}
                className={classes.saveButton}
                submitOnEnter={false}
                undoable={false}
                saving={isSaving || submitting}
                handleSubmitWithRedirect={() =>
                  handleValidateSaveAccept(formData)
                }
                transform={transformAccpet}
                onSuccess={onSuccess}
                onFailure={onFailure}
                icon={<ApproveIcon />}
              />
            )}
          </div>
          <ConditionalConfirm
            isOpen={open}
            loading={isSaving}
            title="Save Confirmation"
            content={confirmContent}
            onConfirm={onConfirm}
            onClose={handleDialogClose}
          />
        </>
      )}
    </FormDataConsumer>
  );
};
